import { render } from "./MsgSend.vue?vue&type=template&id=d2a30010&scoped=true"
import script from "./MsgSend.vue?vue&type=script&lang=js"
export * from "./MsgSend.vue?vue&type=script&lang=js"

import "./MsgSend.vue?vue&type=style&index=0&id=d2a30010&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a30010"]])

export default __exports__